<template>
    <div class="grid grid-cols-1 gap-3 sm:grid-cols-3">
        <button
            v-for="option in options"
            :key="option.value"
            type="button"
            class="rounded-xl border-2 p-2 transition"
            :class="
                selectedId === option.value
                    ? 'border-brand-purple border-4'
                    : 'border-theme-border hover:border-brand-red'
            "
            @click="$emit('select', option)"
        >
            <product-item-design-swatch :option="option" />
        </button>
    </div>
</template>

<script>
import { productCarouselVariantOptions } from "@/components/catalog/product-sliders";
import ProductItemDesignSwatch from "@/components/editor/ProductItemDesignSwatch.vue";

export default {
    name: "ProductItemDesignSelector",
    components: { ProductItemDesignSwatch },
    props: {
        selectedId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            options: productCarouselVariantOptions
        };
    }
};
</script>
